import {
  Vector3
} from 'three'

const data = {
  keypoints: {
    r1: [
      {
        type: 'r1',
        uid: 'r11',
        position: new Vector3(-292, -155, -25),
        rotation: new Vector3(-1.52, -3.3, -1)
      },
      {
        type: 'r1',
        uid: 'r12',
        position: new Vector3(170, -144, -372),
        rotation: new Vector3(-1.5, -3.2, -1)
        // position: new Vector3(-231, -350, 192),
        // rotation: new Vector3(-1.59, -3.1, -1)
      },
      {
        type: 'r1',
        uid: 'r13',
        position: new Vector3(43, -285, 289),
        rotation: new Vector3(-0.45, -2.9, -1)
      },
      // {
      //   type: 'next',
      //   uid: 'next',
      //   position: new Vector3(100, 0, 100),
      //   rotation: new Vector3(0, 0, 0)
      // }
    ],
    r2: [
      {
        type: 'r2',
        uid: 'r21',
        position: new Vector3(-284, -75, 68),
        rotation: new Vector3(1.7, 0.5, 0)
      },
      {
        type: 'r2',
        uid: 'r22',
        position: new Vector3(343, -25, 3.4),
        rotation: new Vector3(1.6, 0.2, 0)
      },
    ]
  }
}

export default data